import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
export var tagIcon = 'tag';
export var formatTags = function formatTags(tags) {
  return tags.map(function (tag) {
    return {
      name: tag.name,
      value: tag.name,
      id: tag.id,
      icon: tagIcon,
      isDisabled: tag.isDisabled,
      isIndeterminate: tag.isIndeterminate
    };
  });
};
export function intersectionById(arr1, arr2) {
  return arr1.filter(function (obj1) {
    return arr2.some(function (obj2) {
      return obj1.id === obj2.id;
    });
  });
}

/*
 * Function to find intersection of team objects based on team id
 */
export function getCommonTeams(teamsList) {
  if (!teamsList.length) {
    return [];
  }

  // Reduce over all the teams arrays, but if an array is empty, intersection will be empty
  var commonTeams = teamsList.reduce(function (common, teams) {
    // If the common or current teams array is empty, return an empty array
    if (!common.length || !teams.length) {
      return [];
    }
    // Otherwise, find the intersection
    return intersectionById(common, teams);
  });
  return commonTeams;
}
export function getIndeterminateTeams(teamsList) {
  var commonTeams = getCommonTeams(teamsList);

  // Get all teams which are not common in all playlists
  var indeterminateTeams = teamsList.reduce(function (indeterminateTeams, teamsList) {
    var teams = teamsList.filter(function (team) {
      return !commonTeams.some(function (commonTeam) {
        return commonTeam.id === team.id;
      });
    });
    return [].concat(_toConsumableArray(indeterminateTeams), _toConsumableArray(teams));
  }, []);

  // Remove duplicates
  indeterminateTeams = indeterminateTeams.filter(function (team, index, self) {
    return self.findIndex(function (t) {
      return t.id === team.id;
    }) === index;
  });
  return indeterminateTeams;
}
export function getCommonAudience(audienceList) {
  var areAudienceAllSame = audienceList.every(function (audience) {
    return audience === audienceList[0];
  });
  return areAudienceAllSame ? audienceList[0] : 'mixed';
}